"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./IronImage.css");
//The purpose of this component is to show a blurred preloaded image in the jumbotron while it is loading the full image
var IronImage = /** @class */ (function (_super) {
    __extends(IronImage, _super);
    function IronImage(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { loaded: false };
        return _this;
    }
    IronImage.prototype.componentDidMount = function () {
        var _this = this;
        var hdLoaderImg = new Image();
        hdLoaderImg.src = this.props.src;
        hdLoaderImg.onload = function () {
            _this.setState({ loaded: true });
        };
    };
    ;
    IronImage.prototype.render = function () {
        var style = {
            backgroundImage: "url('" + this.props.src + "')"
        };
        return (React.createElement("div", { className: "iron-image-container" },
            React.createElement("div", { className: (this.state.loaded ? "iron-image-fade-in" : "") + " iron-image-loaded " + this.props.className, style: this.state.loaded ? style : undefined },
                React.createElement("div", { className: "title" },
                    React.createElement("h3", null, this.props.title))),
            React.createElement("div", { className: this.props.className + " iron-image-preload", style: { backgroundImage: "url(\"" + this.props.placeholder + "\")" } })));
    };
    return IronImage;
}(React.Component));
exports.default = IronImage;
//# sourceMappingURL=IronImage.js.map